"use strict";

!function (o) {
  var n = "autogrow";
  function r(e, i) {
    if ("TEXTAREA" === e.tagName) {
      var t = o(e),
        s = o("<div></div>");
      s.addClass("autogrow-mirror"), void 0 !== i.id && s.attr("id", 0 == index ? i.id : i.id + "-" + index), void 0 !== i.classes && s.addClass(i.classes), t.addClass("autogrow-field").on("input keyup", function (e) {
        var i = t.val();
        i && "\n" != i.charAt(i.length - 1) || (i += " "), i = i.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/ /g, "&nbsp;").replace(/\n/g, "<br/>"), s.html(i), t.height(s.height());
      }).off(n + ".resize").on(n + ".resize", function () {
        s.css({
          border: t.css("border"),
          "font-family": t.css("font-family"),
          "font-size": t.css("font-size"),
          "font-weight": t.css("font-weight"),
          "letter-spacing": t.css("letter-spacing"),
          "line-height": t.css("line-height"),
          padding: t.css("padding"),
          position: "absolute",
          visibility: "hidden",
          "white-space": "normal",
          width: t.css("width"),
          "word-break": "break-word",
          "z-index": -1,
          zoom: t.css("zoom")
        });
      }).trigger(n + ".resize").after(s);
    }
  }
  o.fn[n] = function (t, s) {
    var e = this,
      n = this.context;
    return void 0 === s && (s = t instanceof Object ? t : {}), "string" != typeof t && (t = null), t && (e = o(t, n), o(document).on("DOMNodeInserted", function (e) {
      var i = e.target;
      o(i, n).is(t) && r(i, s);
    })), e.each(function (e, i) {
      r(i, s);
    }), this;
  };
}(jQuery);